import React from 'react';
import { BookOpen, MonitorSmartphone, Globe2, Scale, HeartHandshake, PiggyBank } from 'lucide-react';
const items = [{
  icon: BookOpen,
  tomo: 'TOMO 1',
  title: 'Costituzione, Stato e Cittadinanza',
  color: 'text-blue-600',
  bgColor: 'bg-blue-50',
  borderColor: 'border-blue-200'
}, {
  icon: MonitorSmartphone,
  tomo: 'TOMO 2',
  title: 'Cittadinanza Digitale e Intelligenza Artificiale',
  color: 'text-indigo-600',
  bgColor: 'bg-indigo-50',
  borderColor: 'border-indigo-200'
}, {
  icon: Globe2,
  tomo: 'TOMO 3',
  title: 'Ambiente, Agenda 2030 e Sviluppo Sostenibile',
  color: 'text-emerald-600',
  bgColor: 'bg-emerald-50',
  borderColor: 'border-emerald-200'
}, {
  icon: Scale,
  tomo: 'TOMO 4',
  title: 'Legalità, Giustizia e Convivenza Civile',
  color: 'text-amber-600',
  bgColor: 'bg-amber-50',
  borderColor: 'border-amber-200'
}, {
  icon: HeartHandshake,
  tomo: 'TOMO 5',
  title: 'Diritti Umani, Inclusione e Benessere',
  color: 'text-rose-600',
  bgColor: 'bg-rose-50',
  borderColor: 'border-rose-200'
}, {
  icon: PiggyBank,
  tomo: 'TOMO 6',
  title: 'Educazione Finanziaria ed Economia Quotidiana',
  color: 'text-teal-600',
  bgColor: 'bg-teal-50',
  borderColor: 'border-teal-200'
}];
export function ContentPreview() {
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-23">
      <div className="max-w-6xl mx-auto" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-26">
            Cosa contiene il Kit Educazione Civica Pronta?
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-27">
            6 volumi completi in PDF pronti da stampare o proiettare in classe.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-28">
          {items.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} className="bg-white rounded-3xl border border-border-light shadow-sm hover:shadow-xl transition-all duration-300 p-8 flex flex-col items-start group" data-id="element-29">
                <div className={`w-14 h-14 rounded-2xl ${item.bgColor} border ${item.borderColor} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-30">
                  <Icon className={`w-7 h-7 ${item.color}`} data-id="element-31" />
                </div>

                <span className={`text-sm font-bold tracking-wider mb-2 ${item.color}`} data-id="element-32">
                  {item.tomo}
                </span>

                <h3 className="text-xl sm:text-2xl font-bold text-text-main leading-tight" data-id="element-33">
                  {item.title}
                </h3>
              </div>;
        })}
        </div>
      </div>
    </section>;
}